'use strict';

angular.module('atex.dam').factory('DamAboutModal',
['$rootScope', '$q', '$modal',
function($rootScope, $q, $modal) {

  return {
    create: function(params) {
      var defaultParams = { applicationVersion: '' };

      var syncArgs = _.extend({}, defaultParams, params);
      var modalScope = $rootScope.$new(true);
      modalScope.applicationVersion = syncArgs.applicationVersion;

      var modal = $modal({
        show: true,
        scope: modalScope,
        template: 'views/dam-about-modal.html',
        modalClass: 'dam-modal-edit confirm-modal ng-cloak',
        backdrop: 'static',
        keyboard: false
      });

      var destroyModal = function () {
        modal.then(function (modalEl) {
          modalEl.on('hidden.bs.modal', function () {
            modalScope.$destroy();
            angular.element(this).remove();
          });
          modalEl.modal('hide');
        });
      };

      modalScope.doCancel = function () {
        destroyModal();
      };

      return {
        destroy: function() {
          return modalScope.destroyModal();
        }
      };
    }
  };

}]);
